/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export function createDraggingHandlers(onStart: (event: MouseEvent) => void, onMove: (event: MouseEvent) => void, onEnd: () => void) {
    let dragging = false;
    let lastMoveEvent: MouseEvent | null = null;
    let animationFrame: number | null = null;
    const handleMouseDown = (event: MouseEvent) => {
        dragging = true;
        event.preventDefault();
        onStart(event);
    };

    const handleMouseMove = (event: MouseEvent) => {
        if (dragging) {
            lastMoveEvent = event;
            if (!animationFrame) {
                animationFrame = requestAnimationFrame(() => {
                    if (lastMoveEvent) {
                        onMove(lastMoveEvent);
                        lastMoveEvent = null;
                    }
                    animationFrame = null;
                });
            }
            event.preventDefault();
        }
    };

    const handleMouseUp = () => {
        if (dragging) {
            dragging = false;
            onEnd();
        }
    };

    return { handleMouseDown, handleMouseMove, handleMouseUp };
}

export function createMobileDraggingHandlers(
    onStart: (event: TouchEvent) => void,
    onMove: (event: TouchEvent) => void,
    onEnd: () => void
) {
    let dragging = false;
    let lastMoveEvent: TouchEvent | null = null;
    let animationFrame: number | null = null;

    const handleTouchStart = (event: TouchEvent) => {
        dragging = true;
        event.preventDefault();
        onStart(event);
    };

    const handleTouchMove = (event: TouchEvent) => {
        if (dragging) {
            lastMoveEvent = event;
            if (!animationFrame) {
                animationFrame = requestAnimationFrame(() => {
                    if (lastMoveEvent) {
                        onMove(lastMoveEvent);
                        lastMoveEvent = null;
                    }
                    animationFrame = null;
                });
            }
            event.preventDefault();
        }
    };

    const handleTouchEnd = () => {
        if (dragging) {
            dragging = false;
            onEnd();
        }
    };

    return { handleTouchStart, handleTouchMove, handleTouchEnd };
}

export const resetIframe = () => {
    window.parent.postMessage(
        {
            type: 'flora-chat-iframe-minimised'
        },
        '*'
    );
};
